/**
 * The cron expression a recurring schedule starts from ("daily at 8:00").
 *
 * Lives outside `cron-input.tsx` so pure, React-free code (the scheduler's mode
 * transitions and their unit tests) can seed the same value the input displays,
 * keeping the two in lockstep if this default ever changes.
 */
export const DEFAULT_CRON = "0 8 * * *";
